import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import facebook from './assets/facebook.esm.js';
import instagram from './assets/instagram.esm.js';
import linkedin from './assets/linkedin.esm.js';
import tiktok from './assets/tiktok.esm.js';
import twitter from './assets/twitter.esm.js';
import youtube from './assets/youtube.esm.js';

/* eslint-disable react/jsx-no-target-blank */ function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  gap: 18px;\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  zoom: 0.75;\n\n  li a img {\n    transition: opacity 0.2s ease-in-out;\n  }\n  li a:hover img {\n    opacity: 0.8;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
var socialAccounts = [
    {
        name: "facebook",
        image: facebook,
        link: "https://www.facebook.com/lemonade/"
    },
    {
        name: "twitter",
        image: twitter,
        link: "https://twitter.com/lemonade_inc"
    },
    {
        name: "instagram",
        image: instagram,
        link: "https://instagram.com/lemonade_inc/"
    },
    {
        name: "linkedin",
        image: linkedin,
        link: "https://www.linkedin.com/company/lemonade-inc-"
    },
    {
        name: "youtube",
        image: youtube,
        link: "https://www.youtube.com/lemonade_inc"
    },
    {
        name: "tiktok",
        image: tiktok,
        link: "https://www.tiktok.com/@lemonade.inc"
    }
];
var SocialList = styled.ul(_templateObject());
var SocialLinks = function() {
    return /*#__PURE__*/ jsx(SocialList, {
        children: socialAccounts.map(function(param) {
            var name = param.name, link = param.link, image = param.image;
            return /*#__PURE__*/ jsx("li", {
                children: /*#__PURE__*/ jsx("a", {
                    "aria-label": name,
                    "data-event": "footer_".concat(name, "_clicked"),
                    href: link,
                    rel: "noopener",
                    target: "_blank",
                    children: /*#__PURE__*/ jsx("img", {
                        alt: name,
                        src: image
                    })
                })
            }, name);
        })
    });
};

export { SocialLinks };
